
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/[...slugs]",
      function () {
        return require("private-next-pages/info/[...slugs].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/[...slugs]"])
      });
    }
  